import React, { useState, useCallback } from 'react';
import {
  Grid,
  Card,
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { UserData } from 'services/dataService';
import { toast } from 'react-toastify';
import { exportToXlsx } from 'helpers/reportExport';
import Interweave from 'interweave'

const exportActionType = {
  excel: (col, responseData, title) => {
    exportToXlsx(col, responseData, title);
  },
};

export default () => {
  const classes = useStyles();
  const { t } = useTranslation(['label', 'button', 'form', 'files']);
  const history = useHistory();

  const columns = [
    { title: `name`, field: 'name', example: 'John Doe' },
    { title: `email`, field: 'email', example: 'johndoe@cm.com' },
    { title: `cpf`, field: 'cpf', example: '000.000.000-00' },
    { title: `team`, field: 'team', example: 'Financeiro' },
  ];

  const customExport = useCallback(async (type) => {
    try {
      let responseData = [];
      let responseDataObj = {};
      for (let i in columns) {
        responseDataObj[columns[i].title] = columns[i].example;
      }
      responseData.push(responseDataObj);
      exportActionType[type](columns, responseData, 'xlsTeams.cm42');
    } catch (err) {
      toast.error(`No momento não foi possível baixar o arquivo ${type}`);
    }
  }, []);

  return (
    <div className={classes.root}>
          <Typography style={{marginLeft: 20}}>
            {t('form:Team.Titles.step1_massive')}
          </Typography>
        <Card className={classes.card}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography style={{fontSize: 16}}>
                    <Interweave
                    content={t('form:Team.Configuration.text1_massive')}
                    transform={(node, children) => {
                        if (node.tagName === 'A') {
                        return (
                            <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                customExport('excel');
                            }}
                            className={classes.link}
                            >
                            {children}
                            </a>
                        );
                        }
                    }}
                    />
                </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography style={{fontSize: 16}}>
                    <Interweave content={t('form:Team.Configuration.text2_massive')} />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography style={{fontSize: 16}}>
                    <Interweave content={t('form:Team.Configuration.text3_massive')} />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {/* <Typography>
                    <Interweave content={t('form:Team.Configuration.text4')} />
                    </Typography> */}
                </Grid>
            </Grid>
          <hr className={classes.divider} />

          <Typography
            style={{fontSize: 12}}
            component="div"
            dangerouslySetInnerHTML={{ __html: t('form:Team.Configuration.text4_massive') }}
            />
        </Card>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  button: {
    textTransform: 'capitalize',
    width: '100%',
    marginTop: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  instructions: {
    listStyle: 'none',
    paddingLeft: 0,
    marginTop: theme.spacing(2),
    '& li': {
      marginBottom: theme.spacing(1),
      fontSize: '1rem',
    },
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 500,
  },
  divider: {
    margin: `${theme.spacing(3)}px 0`,
    border: 'none',
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));
